import React, { useState, useEffect } from 'react';
import SEOHead from '../components/SEOHead';
import RelatedServices from '../components/RelatedServices';

// Move font loading outside component to prevent re-execution
if (typeof document !== 'undefined') {
  const existingLink = document.querySelector('link[href*="use.typekit.net"]');
  if (!existingLink) {
    const fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://use.typekit.net/mwi3kgs.css';
    document.head.appendChild(fontLink);
  }
}

// Material Icons Component
const MaterialIcon = ({ name, className = "w-6 h-6" }) => {
  const icons = {
    phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
      </svg>
    ),
    schedule: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
        <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
      </svg>
    ),
    checkCircle: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"/>
      </svg>
    ),
    warning: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
      </svg>
    ),
    close: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    trending_up: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
      </svg>
    ),
    person_add: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
      </svg>
    ),
    contact_phone: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm7.5-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-4c-.83 0-1.5-.67-1.5-1.5S20.67 7.5 21.5 7.5 23 8.17 23 9s-.67 1.5-1.5 1.5z"/>
      </svg>
    ),
    track_changes: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14l4-4-4-4v2.28c-2.64.46-4.78 2.79-4.78 5.64 0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.85-2.14-5.18-4.78-5.64z"/>
      </svg>
    ),
    call_made: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"/>
      </svg>
    ),
    analytics: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
      </svg>
    ),
    star: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
      </svg>
    ),
    speed: (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.38 8.57l-1.23 1.85a8 8 0 0 1-.22 7.58H5.07A8 8 0 0 1 15.58 6.85l1.85-1.23A10 10 0 0 0 3.35 19a2 2 0 0 0 1.72 1h13.85a2 2 0 0 0 1.74-1 10 10 0 0 0-.27-10.44z"/>
        <path d="M10.59 15.41a2 2 0 0 0 2.83 0l5.66-8.49-8.49 5.66a2 2 0 0 0 0 2.83z"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const LeadGeneration = () => {
  const [showWaitlistModal, setShowWaitlistModal] = useState(false);
  const [currentCallType, setCurrentCallType] = useState(0);
  
  const [waitlistData, setWaitlistData] = useState({
    name: '',
    email: '',
    phone: '',
    business: 'lead generation business'
  });
  const [waitlistLoading, setWaitlistLoading] = useState(false);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);

  const callExamples = [
    {
      type: "Solar Installation Inquiry",
      time: "Thursday, 7:20 PM",
      customer: "I'm interested in solar panels for my home. Can someone come out for a quote?",
      response: "I'd be happy to schedule your free solar consultation. I can have our energy specialist visit your home Saturday at 10 AM to assess your roof and provide a custom quote.",
      outcome: "$18,000 lead captured",
      color: "blue"
    },
    {
      type: "Insurance Quote Request",
      time: "Monday, 2:45 PM", 
      customer: "I need car insurance quotes. My current policy expires next week and I want to compare rates.",
      response: "Perfect timing! I can schedule your insurance consultation for Wednesday at 4 PM. Our agent will review your current coverage and provide competitive quotes from multiple carriers.",
      outcome: "$2,400 annual policy",
      color: "blue"
    },
    {
      type: "Home Renovation Lead",
      time: "Saturday, 11:30 AM",
      customer: "We want to remodel our kitchen. Do you provide free estimates?",
      response: "Absolutely! I can schedule your free kitchen design consultation for Tuesday at 6 PM. Our designer will visit your home and create a custom renovation plan with pricing.",
      outcome: "$35,000 project lead",
      color: "blue"
    }
  ];

  const testimonials = [
    {
      quote: "Every phone lead is captured and qualified perfectly. Our lead conversion improved 180% and we never miss a potential customer call.",
      author: "Tom R.",
      business: "Solar Solutions Inc",
      result: "180% lead conversion"
    },
    {
      quote: "The AI qualifies leads better than our sales team and books appointments instantly. Our sales pipeline is always full of qualified prospects.",
      author: "Jennifer L.",
      business: "Premier Insurance Group",
      result: "300% more qualified leads"
    },
    {
      quote: "From initial inquiry to appointment booking, every lead is handled professionally. Our business has grown 220% with zero missed opportunities.",
      author: "Mike S.",
      business: "Elite Home Renovations",
      result: "220% business growth"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCallType(prev => (prev + 1) % callExamples.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const goToLogin = () => {
    window.location.href = '/login';
  };

  const handleWaitlistSubmit = async () => {
    if (!waitlistData.name || !waitlistData.email || !waitlistData.phone) {
      alert('Please fill in all fields');
      return;
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(waitlistData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    setWaitlistLoading(true);
    
    try {
      const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || 'https://sayhi-voice-engine-production.up.railway.app';
      
      const response = await fetch(`${BACKEND_URL}/api/dashboard/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: waitlistData.name.trim(),
          email: waitlistData.email.toLowerCase().trim(),
          phone: waitlistData.phone.trim(),
          trade_business: waitlistData.business
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }
  
      if (data.success) {
        setWaitlistSuccess(true);
        setTimeout(() => {
          setShowWaitlistModal(false);
          setWaitlistSuccess(false);
          setWaitlistData({ name: '', email: '', phone: '', business: 'lead generation business' });
        }, 2000);
      } else {
        throw new Error(data.error || 'Submission failed');
      }
      
    } catch (error) {
      console.error('❌ Waitlist submission error:', error);
      
      if (error.message.includes('already on the waitlist')) {
        alert('This email is already on our waitlist! We\'ll be in touch soon.');
      } else {
        alert(error.message || 'Failed to join waitlist. Please try again or contact support.');
      }
    } finally {
      setWaitlistLoading(false);
    }
  };
  
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
              <MaterialIcon name="close" className="w-6 h-6" />
            </button>
          </div>
          <div className="p-6">{children}</div>
        </div>
      </div>
    );
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": "AI Lead Generation - Never Miss Another Sales Opportunity",
    "description": "How AI receptionists capture and qualify leads 24/7. Perfect for solar, insurance, contractors, and high-value service businesses.",
    "author": {
      "@type": "Organization",
      "name": "Receptioneer.ai"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Receptioneer.ai",
      "url": "https://receptioneer.ai"
    },
    "datePublished": "2025-01-17",
    "dateModified": "2025-01-17"
  };

  return (
    <>
      <SEOHead
        title="AI Lead Generation | Never Miss Another Sales Opportunity 24/7"
        description="AI receptionist captures and qualifies leads 24/7 for solar, insurance, contractors, real estate. Instant lead qualification, appointment booking, perfect follow-up."
        keywords="ai lead generation, lead capture ai, sales lead automation, lead qualification ai, business lead generation, sales automation, lead generation system"
        canonical="https://receptioneer.ai/lead-generation"
        ogTitle="AI Lead Generation - Never Miss Another Sales Opportunity"
        ogDescription="Capture and qualify every sales lead 24/7 with AI. Perfect for solar, insurance, contractors, and high-value service businesses."
        ogImage="https://receptioneer.ai/images/og-image.jpg"
        structuredData={structuredData}
      />
      <div className="bg-white text-gray-900" style={{ fontFamily: '"redonda", sans-serif' }}>
        {/* Header */}
        <header className="bg-white border-b border-gray-200 py-3 px-4 sticky top-0 z-40">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex items-center gap-6">
              <a href="tel:+17863845350" className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Try Live Demo
              </a>
              <button onClick={goToLogin} className="text-blue-900 hover:text-blue-700 font-semibold text-sm">
                Login
              </button>
            </div>
          </div>
        </header>
        
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-green-900 via-green-800 to-green-700 text-white">
          <div className="max-w-6xl mx-auto grid lg:grid-cols-2 min-h-[85vh] items-center">
            <div className="px-6 py-12 lg:py-20">
              <div className="inline-flex items-center bg-green-700 text-white px-4 py-2 rounded-full text-sm font-bold mb-6">
                📈 For Lead Generation
              </div>
              
              <h1 className="text-4xl lg:text-6xl font-black mb-6 leading-tight">
                Never Miss Another
                <br />
                <span className="text-green-200">Sales Opportunity</span>
              </h1>
              
              <p className="text-xl text-green-100 mb-8 leading-relaxed">
                Your AI receptionist captures every lead, qualifies prospects, and books appointments 24/7. Turn every phone call into a sales opportunity.
                <strong className="text-white"> Perfect for high-value service businesses.</strong>
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-12">
                <button 
                  onClick={() => setShowWaitlistModal(true)}
                  className="bg-white text-green-900 hover:bg-green-50 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                >
                  Get Lead Generation AI →
                </button>
                
                <a
                  href="tel:+17863845350"
                  className="flex items-center justify-center gap-3 border-2 border-white text-white hover:bg-white hover:text-green-900 px-6 py-4 rounded-xl font-bold text-lg transition-all duration-300"
                >
                  <MaterialIcon name="phone" className="w-5 h-5" />
                  Test Lead Capture
                </a>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div className="text-center">
                  <div className="text-2xl font-black text-white">24/7</div>
                  <div className="text-green-200 text-sm">Lead Capture</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">100%</div>
                  <div className="text-green-200 text-sm">Qualification</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-black text-white">$0</div>
                  <div className="text-green-200 text-sm">Missed Leads</div>
                </div>
              </div>
            </div>

            <div className="bg-green-800 lg:bg-transparent px-6 py-12 lg:py-20">
              <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-md mx-auto">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-4 h-4 rounded-full animate-pulse bg-green-500"></div>
                  <span className="font-bold text-gray-900">{callExamples[currentCallType].type}</span>
                  <span className="text-xs text-gray-500">{callExamples[currentCallType].time}</span>
                </div>
                
                <div className="space-y-4 mb-6">
                  <div className="bg-gray-50 rounded-lg p-3">
                    <div className="text-xs text-gray-600 font-semibold mb-1">Potential Customer:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].customer}"</div>
                  </div>
                  
                  <div className="rounded-lg p-3 bg-green-50">
                    <div className="text-xs font-semibold mb-1 text-green-600">AI Lead Response:</div>
                    <div className="text-sm text-gray-800">"{callExamples[currentCallType].response}"</div>
                  </div>
                </div>
                
                <div className="text-center">
                  <div className="text-lg font-black text-green-600">{callExamples[currentCallType].outcome}</div>
                  <div className="text-xs text-gray-500">Lead qualified & booked</div>
                </div>

                <div className="flex justify-center gap-2 mt-6">
                  {callExamples.map((_, index) => (
                    <div 
                      key={index}
                      className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                        currentCallType === index ? 'bg-green-600' : 'bg-gray-300'
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Lead Generation Features */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Advanced <span className="text-green-600">Lead Qualification</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              <div className="bg-green-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="person_add" className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Smart Lead Capture</h3>
                <p className="text-gray-700 mb-6">
                  AI instantly captures contact information, understands the customer's needs, and gathers qualifying details without feeling like an interrogation.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li>• Contact info collection</li>
                  <li>• Need assessment</li>
                  <li>• Budget qualification</li>
                  <li>• Timeline identification</li>
                </ul>
              </div>

              <div className="bg-green-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="track_changes" className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Lead Scoring</h3>
                <p className="text-gray-700 mb-6">
                  Automatically scores leads based on budget, timeline, decision-making authority, and urgency. Prioritizes your hottest prospects first.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li>• Automatic lead scoring</li>
                  <li>• Priority classification</li>
                  <li>• Hot lead alerts</li>
                  <li>• CRM integration</li>
                </ul>
              </div>

              <div className="bg-green-50 rounded-3xl p-8">
                <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-6">
                  <MaterialIcon name="speed" className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-xl font-black mb-4 text-gray-900">Instant Follow-up</h3>
                <p className="text-gray-700 mb-6">
                  Books appointments immediately while the lead is hot, sends confirmation details, and ensures your sales team connects with qualified prospects.
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li>• Immediate appointment booking</li>
                  <li>• Confirmation & reminders</li>
                  <li>• Sales team notifications</li>
                  <li>• Lead nurturing sequence</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Perfect For Industries */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Perfect for <span className="text-green-600">High-Value Businesses</span>
            </h2>
            
            <div className="grid lg:grid-cols-2 gap-8">
              <div className="space-y-6">
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="trending_up" className="w-8 h-8 text-yellow-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Solar & Energy</h3>
                    <p className="text-gray-700">Solar installations, energy audits, and renewable energy systems with high-ticket sales requiring consultation.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="contact_phone" className="w-8 h-8 text-blue-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Insurance & Financial</h3>
                    <p className="text-gray-700">Life insurance, auto insurance, financial planning, and investment services with complex qualification needs.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="call_made" className="w-8 h-8 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Home Improvements</h3>
                    <p className="text-gray-700">Kitchen remodels, bathroom renovations, roofing, windows, and major home improvement projects.</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="analytics" className="w-8 h-8 text-purple-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Real Estate</h3>
                    <p className="text-gray-700">Real estate agents, property management, commercial real estate, and investment property services.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="star" className="w-8 h-8 text-red-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">Professional Services</h3>
                    <p className="text-gray-700">Legal services, accounting, consulting, marketing agencies, and business services requiring lead qualification.</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-sm">
                  <MaterialIcon name="trending_up" className="w-8 h-8 text-indigo-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-lg text-gray-900 mb-2">B2B Services</h3>
                    <p className="text-gray-700">Software sales, enterprise solutions, business consulting, and any B2B service with complex sales cycles.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Lead Generation Benefits */}
        <section className="py-16 px-6 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Why AI Lead Generation <span className="text-green-600">Wins</span>
            </h2>
            
            <div className="grid lg:grid-cols-2 gap-8">
              <div className="bg-green-50 rounded-3xl p-8">
                <h3 className="text-2xl font-black mb-6 text-gray-900 flex items-center gap-3">
                  <MaterialIcon name="checkCircle" className="w-8 h-8 text-green-600" />
                  AI Advantage
                </h3>
                
                <ul className="space-y-4 text-gray-700">
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                    <span><strong>24/7 Lead Capture:</strong> Never miss a potential customer call</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                    <span><strong>Perfect Qualification:</strong> Consistent questions every time</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                    <span><strong>Instant Appointment Booking:</strong> Strike while leads are hot</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                    <span><strong>Lead Scoring:</strong> Prioritizes your hottest prospects</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="checkCircle" className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                    <span><strong>CRM Integration:</strong> Seamless lead management</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gray-100 rounded-3xl p-8">
                <h3 className="text-2xl font-black mb-6 text-gray-900 flex items-center gap-3">
                  <MaterialIcon name="warning" className="w-8 h-8 text-red-600" />
                  Manual Lead Problems
                </h3>
                
                <ul className="space-y-4 text-gray-700">
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" />
                    <span><strong>Missed Calls:</strong> Lose leads to voicemail black holes</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" />
                    <span><strong>Inconsistent Qualification:</strong> Different questions each time</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" />
                    <span><strong>Delayed Follow-up:</strong> Leads go cold while waiting</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" />
                    <span><strong>Poor Lead Tracking:</strong> Leads fall through cracks</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <MaterialIcon name="warning" className="w-5 h-5 text-red-600 flex-shrink-0 mt-1" />
                    <span><strong>Staff Training:</strong> Expensive and inconsistent</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-16 px-6 bg-gray-50">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl lg:text-4xl font-black mb-12 text-center text-gray-900">
              Sales Teams Love <span className="text-green-600">AI Lead Generation</span>
            </h2>
            
            <div className="grid lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="bg-white rounded-3xl p-8 shadow-sm">
                  <div className="flex items-center gap-3 mb-6">
                    <MaterialIcon name="trending_up" className="w-8 h-8 text-green-600" />
                    <div>
                      <div className="font-bold text-gray-900">{testimonial.author}</div>
                      <div className="text-sm text-gray-600">{testimonial.business}</div>
                    </div>
                  </div>
                  <p className="text-gray-700 mb-6 italic">"{testimonial.quote}"</p>
                  <div className="bg-green-50 rounded-xl p-4 text-center">
                    <div className="text-lg font-black text-green-900">{testimonial.result}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ROI Section */}
        <section className="py-16 px-6 bg-green-900 text-white">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-black mb-8">
              One Lead Pays for Everything
            </h2>
            
            <p className="text-xl text-green-100 mb-8">
              Whether your average sale is $2,000 or $20,000, just one captured lead per month pays for your entire AI lead generation system.
            </p>
            
            <div className="bg-white/10 rounded-3xl p-8 mb-8">
              <div className="text-6xl lg:text-7xl font-black mb-4">$399</div>
              <div className="text-xl text-green-100 mb-6">per month • unlimited leads • perfect qualification</div>
              
              <button 
                onClick={() => setShowWaitlistModal(true)}
                className="w-full bg-white text-green-900 hover:bg-green-50 py-4 rounded-xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Get Lead Generation AI →
              </button>
            </div>
            
            <p className="text-green-200">Ready in 24 hours • Cancel anytime • ROI guaranteed</p>
          </div>
        </section>

        {/* Waitlist Modal */}
        <Modal
          isOpen={showWaitlistModal}
          onClose={() => setShowWaitlistModal(false)}
          title="Get Your Lead Generation AI"
        >
          {waitlistSuccess ? (
            <div className="text-center">
              <MaterialIcon name="checkCircle" className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-2">You're all set!</h3>
              <p className="text-gray-600">We'll have your lead generation AI ready within 24 hours of launch.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Your Name</label>
                <input
                  type="text"
                  required
                  value={waitlistData.name}
                  onChange={(e) => setWaitlistData({...waitlistData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                  placeholder="e.g. Tom Rodriguez"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Email</label>
                <input
                  type="email"
                  required
                  value={waitlistData.email}
                  onChange={(e) => setWaitlistData({...waitlistData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                  placeholder="tom@solarsolutions.com"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Business Phone</label>
                <input
                  type="tel"
                  required
                  value={waitlistData.phone}
                  onChange={(e) => setWaitlistData({...waitlistData, phone: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
                  placeholder="(555) 123-4567"
                />
              </div>
              
              <button
                onClick={handleWaitlistSubmit}
                disabled={waitlistLoading}
                className="w-full bg-green-900 hover:bg-green-800 text-white py-3 px-6 rounded-lg font-bold disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {waitlistLoading ? 'Setting Up Your AI...' : 'Get My Lead Generation AI'}
              </button>
            </div>
          )}
        </Modal>

        {/* Related Services */}
        <RelatedServices currentService="/lead-generation" />

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-8 px-6">
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-lg font-black text-blue-900">
              <a href="/">receptioneer.ai</a>
            </div>
            <div className="flex gap-6 text-sm text-gray-600">
              <a href="/privacy" className="hover:text-blue-900">Privacy</a>
              <a href="/terms" className="hover:text-blue-900">Terms</a>
              <a href="mailto:support@receptioneer.ai" className="hover:text-blue-900">Support</a>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default LeadGeneration;